module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8bce2aa48a3393eb61cc3af660946d67.png";